import { render, staticRenderFns } from "./NavPopover.vue?vue&type=template&id=0cc00e6e&"
import script from "./NavPopover.vue?vue&type=script&lang=ts&"
export * from "./NavPopover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppLazyHydrate: require('/home/vsts/work/1/a/NuxtApp/components/app/LazyHydrate.vue').default})
